<div class="pt-4 flex flex-col gap-4">

  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.location-address' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4 flex flex-col gap-4">
      <app-localized-text-editor
        [nl]="form.controls.locationAddressNl"
        [en]="form.controls.locationAddressEn"
        [de]="form.controls.locationAddressDe"
        [it]="form.controls.locationAddressIt"
        [fr]="form.controls.locationAddressFr"
      />
      <mat-form-field>
        <mat-label>{{ 'waters.information.location-coordinates' | translate }}</mat-label>
        <input matInput [formControl]="form.controls.locationCoordinates" />
      </mat-form-field>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.map-image' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4">
      <app-image-field
        [currentImageName]="mapImageName()"
        [currentImageUrl]="mapImageUrl()"
        (fileSelected)="uploadImage.emit({ type: WaterInfoImageType.Map, file: $event })"
        (cleared)="deleteImage.emit(WaterInfoImageType.Map)"
      />
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.location-image' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4">
      <app-image-field
        [currentImageName]="locationImageName()"
        [currentImageUrl]="locationImageUrl()"
        (fileSelected)="uploadImage.emit({ type: WaterInfoImageType.Location, file: $event })"
        (cleared)="deleteImage.emit(WaterInfoImageType.Location)"
      />
    </mat-card-content>
  </mat-card>

</div>
